module.exports = __webpack_public_path__ + "img/zhengshu5.81f31d81.png";